import React, { useCallback, useEffect, useMemo, useState } from "react";
import { defaultInvoiceFields } from "../../constants/invoiceFields.constants";
import CustomInput from "../../components/CustomInput";
import { deepClone, toCamelCase } from "../../helpers/objectHelper";
import { runInAction } from "mobx";
import { observer } from "mobx-react-lite";
import { invoiceFieldValidator } from "../../helpers/inputValidator.helper";

export const InvoiceFields = observer((props) => {
  const { activePersonNo, orders, updateOrder, validations, environment, validate } = props;
  const [initValidation, setInitValidation] = useState(true);

  useEffect(() => {
    if (orders && orders[activePersonNo]?.badgeNo && initValidation) {
      setInitValidation(false);
      defaultInvoiceFields.map((di) => {
        let value = getFieldValue(di);
        handleValueChange(value, di);
      });
    }
  }, [orders]);

  const handleValueChange = (value, t) => {
    const validity = validations.find((v) => v.id == `INVOICE_${t}`);

    let order = orders[activePersonNo];
    let newOrder = deepClone(order);
    let type = newOrder["invoice"];
    let newType = undefined;

    if (!type) {
      newType = {};
    } else {
      newType = deepClone(type);
    }
    newType[toCamelCase(t)] = value;
    newOrder["invoice"] = newType;

    updateOrder(newOrder);

    //validate
    let isValid = invoiceFieldValidator(value, t, newType.countryCode ?? null);
    if (t == "CountryCode") {
      const orgNoValidity = validations.find((v) => v.id == `INVOICE_OrgNo`);
      runInAction(() => {
        orgNoValidity.valid = invoiceFieldValidator(newType[toCamelCase("OrgNo")], "OrgNo", newType.countryCode);
      });
    }

    runInAction(() => {
      validity.valid = isValid;
    });

    //validate
  };

  const getFieldValue = (name) => {
    if (orders.length > 0) {
      let order = orders[activePersonNo];
      let type = order["invoice"];
      if (type) {
        let val = type[toCamelCase(name)];
        if (val) {
          return val;
        }
      }
    }
    return "";
  };

  const isRequired = (type) => {
    switch (type) {
      case "Email":
      case "Telephone1":
      case "Address2":
        return false;
      default:
        return true;
    }
  };

  const invoiceFields = useMemo(() => {
    return defaultInvoiceFields.map((di) => {
      const validity = validations.find((v) => v.id == `INVOICE_${di}`);
      if (validate && validity?.valid === false) {
        return { type: di, valid: false };
      }
      if (validity?.valid === false && getFieldValue(di)?.length > 0) {
        return { type: di, valid: false };
      }
      return { type: di, valid: undefined };
    });
  }, [validations, validate, getFieldValue]);

  console.log(invoiceFields);

  return invoiceFields.map(({ type, valid }) => (
    <React.Fragment key={type}>
      <CustomInput
        required={isRequired(type)}
        prefixClassName={"cms-field invoice"}
        value={getFieldValue(type)}
        onChange={(val) => (type == "CountryCode" ? handleValueChange(val, type) : handleValueChange(val.target.value, type))}
        label={type}
        valid={valid}
        staticLabel={true}
        type={type}
        lang={environment.lang}
        eventId={environment.eventId}
      />
    </React.Fragment>
  ));
});
